/// <reference types="./murmur3a.d.mts" />
import * as $bit_array from "../gleam_stdlib/gleam/bit_array.mjs";
import * as $int from "../gleam_stdlib/gleam/int.mjs";
import {
  bitwise_and as and,
  bitwise_exclusive_or as xor,
  bitwise_or as or,
  bitwise_shift_left as shift_left,
  bitwise_shift_right as shift_right,
} from "../gleam_stdlib/gleam/int.mjs";
import * as $list from "../gleam_stdlib/gleam/list.mjs";
import * as $string from "../gleam_stdlib/gleam/string.mjs";
import { CustomType as $CustomType, toBitArray, sizedInt } from "./gleam.mjs";
import { signed_multiply } from "./murmur3a_ffi.mjs";

class Hash extends $CustomType {
  constructor(seed, shift, state) {
    super();
    this.seed = seed;
    this.shift = shift;
    this.state = state;
  }
}

export function int_digest(hash) {
  return hash.state;
}

export function bit_array_digest(hash) {
  return toBitArray([sizedInt(int_digest(hash), 32, true)]);
}

export function hex_digest(hash) {
  let _pipe = hash;
  let _pipe$1 = bit_array_digest(_pipe);
  return $bit_array.base16_encode(_pipe$1);
}

const c1 = 0xcc9e2d51;

const c2 = 0x1b873593;

const m1 = 0xffffffff;

function rotate_left(n, shift) {
  let n$1 = and(n, m1);
  let _pipe = shift_left(n$1, shift);
  let _pipe$1 = and(_pipe, m1);
  return or(_pipe$1, shift_right(n$1, 32 - shift));
}

function mix(state, seed) {
  let _pipe = state;
  let _pipe$1 = signed_multiply(_pipe, c1);
  let _pipe$2 = rotate_left(_pipe$1, 15);
  let _pipe$3 = signed_multiply(_pipe$2, c2);
  let _pipe$4 = xor(_pipe$3, seed);
  let _pipe$5 = rotate_left(_pipe$4, 13);
  let _pipe$6 = signed_multiply(_pipe$5, 5);
  return $int.add(_pipe$6, 0xe6546b64);
}

function hash_chunk(hash, chunk) {
  let _block;
  let _pipe = chunk;
  let _pipe$1 = and(_pipe, 0xff);
  let _pipe$2 = shift_left(_pipe$1, hash.shift);
  _block = or(_pipe$2, hash.state);
  let state = _block;
  let $ = hash.shift;
  if ($ === 24) {
    return new Hash(mix(state, hash.seed), 0, 0);
  } else {
    let _record = hash;
    return new Hash(_record.seed, hash.shift + 8, state);
  }
}

function finalize(hash, length) {
  let _block;
  let _block$1;
  let $ = hash.state;
  if ($ === 0) {
    _block$1 = hash.seed;
  } else {
    let _pipe = hash.state;
    let _pipe$1 = signed_multiply(_pipe, c1);
    let _pipe$2 = rotate_left(_pipe$1, 15);
    let _pipe$3 = signed_multiply(_pipe$2, c2);
    let _pipe$4 = xor(_pipe$3, hash.seed);
    _block$1 = and(_pipe$4, m1);
  }
  let _pipe = _block$1;
  _block = xor(_pipe, length);
  let state = _block;
  let _block$2;
  let _pipe$1 = shift_right(state, 16);
  let _pipe$2 = xor(_pipe$1, state);
  let _pipe$3 = signed_multiply(_pipe$2, 0x85ebca6b);
  _block$2 = and(_pipe$3, m1);
  let state$1 = _block$2;
  let _block$3;
  let _pipe$4 = shift_right(state$1, 13);
  let _pipe$5 = xor(_pipe$4, state$1);
  _block$3 = signed_multiply(_pipe$5, 0xc2b2ae35);
  let state$2 = _block$3;
  let _record = hash;
  return new Hash(
    _record.seed,
    _record.shift,
    (() => {
      let _pipe$6 = shift_right(state$2, 16);
      let _pipe$7 = and(_pipe$6, 0xffff);
      return xor(_pipe$7, state$2);
    })(),
  );
}

export function hash_ints(key, seed) {
  let _pipe = key;
  let _pipe$1 = $list.fold(_pipe, new Hash(seed, 0, 0), hash_chunk);
  return finalize(_pipe$1, $list.length(key));
}

export function hash_string(key, seed) {
  let _pipe = key;
  let _pipe$1 = $string.to_utf_codepoints(_pipe);
  let _pipe$2 = $list.map(_pipe$1, $string.utf_codepoint_to_int);
  return hash_ints(_pipe$2, seed);
}
